/*
export interface PagedData<T> {
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    size: number;
    totalElements: number;
    totalPages: number;
    content: Array<T>;
}
*/

export class PaginatedFetcher<T> {
    private baseUrl: string;
    private pageSize: number;
    private controller: AbortController | null;
    public isCancelled: boolean;
    private jwt: string | null;
    private orgid: string | null;
    private path: string;

    constructor(path: string, pageSize = 1000) {
        this.baseUrl = 'https://localhost:8080';

        if (window.location.host == 'localhost') {
            this.baseUrl = 'https://localhost:8080';
        } else {
            this.baseUrl = 'https://www.dynamiciotdata.com:8080';
        }

        this.path = path;
        this.pageSize = pageSize;
        this.controller = null;
        this.isCancelled = false;
        this.jwt = localStorage.getItem('vision-jwt');
        this.orgid = localStorage.getItem('orgId');
    }

    async fetchAllPagesComplete(onPageLoaded: (data: T[], page: number, totalPages: number) => void, onComplete: () => void): Promise<void> {
        let page = 0;
        let totalPages = 1; // Assume at least 1 page
        //const allData: T[] = [];

        this.isCancelled = false;
        this.controller = new AbortController();

        while (page < totalPages && !this.isCancelled) {
            try {
                const url = this.baseUrl + '/api/' + this.orgid + this.path;

                const response = await fetch(url + '&page=' + page + '&size=' + this.pageSize, {
                    signal: this.controller.signal,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + this.jwt,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data: { content: T[]; totalPages: number } = await response.json();
                //allData.push(...data.content);

                onPageLoaded(data.content, page, totalPages);

                totalPages = data.totalPages; // Update total pages dynamically
                page++; // Move to next page
            } catch (error) {
                if (this.isCancelled) {
                    console.log('Fetch cancelled by user.');
                } else {
                    console.error('Error fetching page:', error);
                }
                break;
            }
        }

        if (!this.isCancelled) {
            onComplete(); // Call completion callback when all pages are processed
        }

        //return allData;
    }

    async fetchAllPages(onPageLoaded: (data: T[], page: number, totalPages: number) => void): Promise<void> {
        let page = 0;
        let totalPages = 1; // Assume at least 1 page
        //const allData: T[] = [];

        this.isCancelled = false;
        this.controller = new AbortController();

        while (page < totalPages && !this.isCancelled) {
            try {
                const url = this.baseUrl + '/api/' + this.orgid + this.path;

                const response = await fetch(url + '&page=' + page + '&size=' + this.pageSize, {
                    signal: this.controller.signal,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + this.jwt,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data: { content: T[]; totalPages: number } = await response.json();
                //allData.push(...data.content);

                onPageLoaded(data.content, page, totalPages);

                totalPages = data.totalPages; // Update total pages dynamically
                page++; // Move to next page
            } catch (error) {
                if (this.isCancelled) {
                    console.log('Fetch cancelled by user.');
                } else {
                    console.error('Error fetching page:', error);
                }
                break;
            }
        }

        //return allData;
    }

    public cancel(): void {
        this.isCancelled = true;
        this.controller?.abort(); // Cancel ongoing request
    }
}
